import React, {useRef, useState} from 'react';
import {Button, Select, Space, Tag, Typography} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import ENDPOINTS from '../../constants/endpoints';
import {formatPath, ROUTES} from '../../constants/PathRoutes';
import SearchTable from '../../components/admin/SearchTable';
import {dateFormat, moneyMask} from '../../utils/utils';
import {ORDER_STATUS_COLOR} from '../../utils/colors';

const STATUS_OPTIONS = [
    {value: '', label: 'Todos'},
    {value: 'PENDING_PAYMENT', label: 'Aguardando Pagamento'},
    {value: 'PAID', label: 'Pago'},
    {value: 'PREPARING', label: 'Em Preparo'},
    {value: 'SHIPPED', label: 'Enviado'},
    {value: 'DELIVERED', label: 'Entregue'},
    {value: 'CANCELLED', label: 'Cancelado'},
];

export default function AdminOrderList() {
    const tableRef = useRef();
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState('');

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 60,
        },
        {
            title: 'Nº Pedido',
            dataIndex: 'order_number',
            key: 'order_number',
        },
        {
            title: 'Cliente',
            dataIndex: 'client_name',
            key: 'client_name',
            render: (name) => name || '-',
        },
        {
            title: 'Data',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (date) => dateFormat(date) || '-',
        },
        {
            title: 'Status',
            dataIndex: 'status_display',
            key: 'status',
            render: (statusDisplay, record) => (
                <Tag color={ORDER_STATUS_COLOR[record.status] ?? 'default'}>
                    {statusDisplay ?? '-'}
                </Tag>
            ),
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            render: (value) => (value ? `R$ ${moneyMask(value)}` : '-'),
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Button
                    size="small"
                    icon={<EyeOutlined/>}
                    onClick={() =>
                        navigate(formatPath(ROUTES.ADMIN_ECOMMERCE_ORDER_DETAIL, {id: record.id}))
                    }
                />
            ),
        },
    ];

    return (
        <>
            <Space style={{marginBottom: 16}} wrap>
                <Typography.Text strong>Status:</Typography.Text>
                <Select
                    value={statusFilter}
                    onChange={setStatusFilter}
                    options={STATUS_OPTIONS}
                    style={{width: 220}}
                />
            </Space>
            <SearchTable
                key={statusFilter}
                ref={tableRef}
                url={ENDPOINTS.ECOMMERCE_STAFF_ORDER_LIST}
                params={statusFilter ? {status: statusFilter} : {}}
                columns={columns}
                title="Pedidos"
            />
        </>
    );
}
